import React from "react";
import {useSelector} from "react-redux";
import {trim} from "@awe-web/shared/lib";
import {Translation as T, useTranslation} from "@awe-web/shared/lib";
import { getRentContractId } from "@awe-web/shared/lib";

import {ScreenSection, ScreenHeading} from "../../../components/screen.js";
import {B2C_STR_SubmitRentContract, B2C_SelectStationAndTime} from "../../../routing/routes.js";
import {TypeArea} from "../../../components/layout.js";
import {Row, Col} from "../../../components/grid.js";
import {Button} from "../../../components/form.js";

const REGISTRATION_EXTENDED = "FSD0000309";
const DATA_SUCCESSFULLY_SAVED = "FSD0000310";
const RESUME_RESERVATION = "FSD0000211";
const REGISTRATION_EXTENDED_MOOD_PICTURE = "FSD0000348";

export default function B2C_SignUpExtended() {
  const {translate} = useTranslation();
  const rentContractId = useSelector((state) => getRentContractId(state));
  
  const signUpExtendedHeadImage = trim(translate(REGISTRATION_EXTENDED_MOOD_PICTURE));

  const resumeButtonTarget = rentContractId
    ? B2C_STR_SubmitRentContract.location({rentContractId})
    : B2C_SelectStationAndTime.location();

  return (
    <div className="sign-up-extended">
      <ScreenSection main dark>
        <TypeArea>
            <Row>
              <Col desktop={{cols: 8, offset: 2}}>
                <ScreenHeading><T code={REGISTRATION_EXTENDED} /></ScreenHeading>
                <p><T code={DATA_SUCCESSFULLY_SAVED} /></p>
              </Col>
            </Row>
            <Row alignBottom>
              <Col desktop={{cols: 4, offset: 2}} tablet={{cols: 4}}>
                <img className="sign-up-confirmed__head-image" src={signUpExtendedHeadImage} alt="" />
              </Col>
              <Col desktop={{cols: 4}} tablet={{cols: 4}}>
                <Button secondary continue to={resumeButtonTarget}><T code={RESUME_RESERVATION} /></Button>
              </Col>
            </Row>
        </TypeArea>
      </ScreenSection>
    </div>
  );
}